import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import * as parentPasswordModalActions from '@/components/modals/parentPasswordModal/Actions';
import { parentPasswordModalActionTypes } from '@/components/modals/parentPasswordModal/Constants';
import { COOKIES, IS_LOCAL_ENVIRONMENT, SQULA_ROUTES_API } from '@/services/Constants';
import { isSecure, setCookie } from '@/services/Helper';
import { getAccessToken } from '@/services/AccessToken';
import { processRequest } from '@/services/Api';
import { historyPush } from '@/services/History';

import type { SagaIterator } from 'redux-saga';

export default function* parentPasswordModalSaga(): SagaIterator {
	yield all([
		takeLatest(
			parentPasswordModalActionTypes.VALIDATE_PARENT_PASSWORD_REQUEST,
			handleValidateParentPasswordRequest,
		),
	]);
}

export function* handleValidateParentPasswordRequest({ payload }: any): SagaIterator {
	try {
		const { password, rememberMe, onSuccessPath } = payload;
		const formData = new FormData();
		formData.append('password', password);

		let data: { success?: boolean } | undefined;

		if (IS_LOCAL_ENVIRONMENT) {
			data = { success: true };
		} else {
			const response = yield call(
				processRequest,
				SQULA_ROUTES_API.SQULA_VALIDATE_PARENT_PASSWORD,
				'POST',
				formData,
				false, // file parameter
				false, // typoChecker parameter
				{
					Authorization: `JWT ${getAccessToken() || ''}`,
					'Content-Type': 'multipart/form-data',
				}, // headers,
				true, // isFullUrl parameter
			);
			data = response?.data;
		}

		if (data?.success) {
			// If remember me is checked, set a cookie that will last for 7 days
			if (rememberMe) {
				setCookie(COOKIES.parentPasswordVerified, 'true', {
					expires: 7, // 7 days
					secure: isSecure(),
				});
			}

			yield put(parentPasswordModalActions.validateParentPasswordSuccess());
			yield put(parentPasswordModalActions.closeParentPasswordModal());
			// redirect to page
			if (onSuccessPath) {
				yield call(historyPush, onSuccessPath);
			}
		} else {
			yield put(
				parentPasswordModalActions.validateParentPasswordError(
					'Incorrect password. Please try again.',
				),
			);
		}
	} catch (e) {
		yield put(
			parentPasswordModalActions.validateParentPasswordError(
				'Something went wrong. Please try again.',
			),
		);
		yield put(errorHandlerActions.handleError(e, 'notification'));
	}
}
